import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (props: templates.HeaderPreviewTemplate) => (
    <PageSkeleton
        headerOverride={props.model}
        {...(undefined as unknown as React.ComponentProps<typeof PageSkeleton>)} // This is only for preview, let the runtime error
        title="Nav preview"
        isPreview
    >
        <h1>{t`Hello World!`}</h1>
    </PageSkeleton>
);
